import VueRouter from 'vue-router'
import store from '../vuex/store.js'
import axios from 'axios'
import * as dateutils from '../DateTimeUtils'

let routes = [
    {
        path: '/',
        name: 'home',
        component: require('../pages/Home').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/video-consultation',
        name: 'videoConsultation',
        component: require('../pages/VideoConsultation').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/search-doctor',
        name: 'searchDoctor',
        component: require('../pages/SearchDoctor').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/book-appointment',
        name: 'bookAppointment',
        component: require('../pages/BookAppointment').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/appointment/:id',
        name: 'appointmentCreated',
        component: require('../pages/AppointmentCreated').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/patient-login',
        name: 'patientLogin',
        component: require('../pages/Login').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/for-providers',
        name: 'forProviders',
        component: require('../pages/ForProviders').default,
        meta: {
            showHeader: false,
        }
    },
    {
        path: '/faq',
        name: 'faq',
        component: require('../pages/FAQ').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/ask-a-question',
        name: 'askAQuestion',
        component: require('../pages/QnA').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/detail/ask-a-question/:slug/:id',
        name: 'askAQuestionDetail',
        component: require('../pages/QuestionDetails').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/doctors/:unique_no/:slug',
        name: 'DoctorDetails',
        component: require('../pages/DoctorDetails').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/refund-policy',
        name: 'RefundPolicy',
        component: require('../pages/RefundPolicy').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: require('../pages/PrivacyPolicy').default,
        meta: {
            showHeader: true,
        }
    },
    {
        path: '/terms-and-conditions',
        name: 'TermsAndConditions',
        component: require('../components/Login/TermsAndConditions').default,
        meta: {
            showHeader: true,
        }
    },
];

let router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach(
    (to, from, next) => {
        let accessToken = store.getters.accessToken ? store.getters.accessToken : localStorage.getItem('accessToken')
        // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (!store.getters.accessToken) {
            let loginObject = {
                accessToken: accessToken,
                userId: localStorage.getItem('userId'),
                userType: localStorage.getItem('userType'),
                userInfo: JSON.parse(localStorage.getItem('userInfo')),
                registration: JSON.parse(localStorage.getItem('registration')),
                education: JSON.parse(localStorage.getItem('education')),
                mobile: localStorage.getItem('mobile'),
                timezone: localStorage.getItem('timezone'),
            }
            store.dispatch('setUserState', loginObject)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accessToken
            dateutils.setTimezone(loginObject.timezone)
        }
        next()
    }
)


export default router